import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DarkAwareSkeletonTheme from "../../DarkAwareSkeletonTheme";

const NotificationSkeletonCard = () => (
  <div className="notification-skeleton-card" aria-hidden="true">
    <Skeleton width={36} height={36} borderRadius={8} />
    <div className="notification-skeleton-card__body">
      <Skeleton height={16} width="42%" borderRadius={4} />
      <Skeleton height={14} width="78%" borderRadius={4} />
      <Skeleton height={12} width="34%" borderRadius={4} />
    </div>
  </div>
);

const NotificationListSkeleton = ({ rows = 5 }) => (
  <DarkAwareSkeletonTheme>
    <div
      className="notification-list-skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading notifications"
    >
      {Array.from({ length: rows }).map((_, index) => (
        <NotificationSkeletonCard key={index} />
      ))}
    </div>
  </DarkAwareSkeletonTheme>
);

export default NotificationListSkeleton;
